export default {
    iWant: 'Acesse agora',
    unblockNow: 'Desbloquear agora!',
    calendars: 'Previsões Pessoais e Mundiais',
    articles: 'Calendário Astrológico e Lunar',
    predictions: 'Artigos, Tarot, Rituais e Simpatias',
    accessNow: 'Acesse agora e entre',
    bePremium: 'Seja Premium e desbloqueie agora<br/>esse e vários outros benefícios!',
    start2021: 'em 2021 com o pé direito',
};